import PropTypes from "prop-types";

import HeaderLogo from "./Components/HeaderLogo";
import SupportedBrokers from "shared/SupportedBrokers";
import { BrokerListViewContainer } from "./SnaptradeModal.styles";

const BrokerListView = ({ show, onHide, onBrokerSelect, isConnectedPage }) => {
  const handleBrokerSelect = (broker) => {
    if (isConnectedPage && broker.display_name.includes("Surmount")) {
      return;
    }
    onBrokerSelect(broker);
  };

  return (
    <BrokerListViewContainer heading="" show={show} onHide={onHide}>
      <HeaderLogo />
      <h2 className="heading">Connect to your broker</h2>
      <div className="content-wrapper">
        <SupportedBrokers
          onBrokerSelect={handleBrokerSelect}
          listHeight={420}
        />
      </div>
    </BrokerListViewContainer>
  );
};

BrokerListView.propTypes = {
  show: PropTypes.bool,
  isConnectedPage: PropTypes.bool,
  onHide: PropTypes.func,
  onBrokerSelect: PropTypes.func,
};

BrokerListView.displayName = "BrokerListView";

export default BrokerListView;
